import React from "react";
import Layout from "../../layouts/index";
import VehicleRegistrationScreen from "../../screens/onbording_web/VehicleRegistration";

const VehicleRegistration = () => {
  return (
    <Layout>
      <VehicleRegistrationScreen />
    </Layout>
  );
};

export default VehicleRegistration;
